import { ActionMaterial } from 'models/order-input/lab-order';
import { MaterialMacroOption } from 'models/material-macro';

/**
 * Emitted by the actions grid whenever the user picks an action that has material
 * macros and/or actionMaterials configured. Carries the label fields too so a
 * deferred prompt can name the product it is asking about.
 */
export type ActionSelectionPayload = {
    actionId: string;
    actionCode: string;
    description: string;
    // Both macro materials and actionMaterials inherit this. Flows that prompt after the action is saved should
    // refresh it from the live grid row, since the user can edit it before saving.
    quantity: string;
    // Every macro linked to the action, usable or not - the picker shows the unusable ones
    // disabled with a reason rather than hiding them.
    materialMacroOptions: MaterialMacroOption[];
    actionMaterials: ActionMaterial[];
    isActionMaterialRequired: boolean;
};

export const actionSelectionLabel = (selection: ActionSelectionPayload): string => {
    return [selection.actionCode, selection.description].filter(Boolean).join(' - ');
};
